import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';
import app from './app';
import authentaLink from './authentaLink';
import exceptions from './exceptions';
import taxForm from './form';
import supportingDocuments from './supportingDocuments';
import fileUploads from './fileUploads';
import preQualifyingQuestionnaire from './preQualifyingQuestionnaire';
import formQuestionnaire from './formQuestionnaire';

function reduceReducers(...reducers) {
  return (previous, current) => reducers.reduce((p, r) => r(p, current), previous);
}

const combinedFormReducer = reduceReducers(taxForm, formReducer);

const createRootReducer = history => combineReducers({
  app,
  authentaLink,
  exceptions,
  form: combinedFormReducer,
  supportingDocuments,
  fileUploads,
  preQualifyingQuestionnaire,
  formQuestionnaire,
  router: connectRouter(history)
});

export default createRootReducer;
